import { render, staticRenderFns } from "./SharePlans.vue?vue&type=template&id=5d00c2f8&scoped=true"
import script from "./SharePlans.vue?vue&type=script&lang=js"
export * from "./SharePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00c2f8",
  null
  
)

export default component.exports